
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class EditCampaignLoader extends Vue {}
